import { DateTime } from 'luxon';

export const isAfterTodaysCutoff = (
  dateString: string | undefined
): boolean => {
  if (!dateString) {
    return false;
  }

  const centralTimeZone = 'America/Chicago';

  const created = DateTime.fromISO(dateString).setZone(centralTimeZone);
  const now = DateTime.now().setZone(centralTimeZone);
  let cutoff = now.set({ hour: 2, minute: 0, second: 0, millisecond: 0 });

  // If current time is before 2AM, set cutoff to yesterday's date at 2AM
  if (now.hour < 2) {
    cutoff = cutoff.minus({ days: 1 });
  }

  return created >= cutoff;
};
